<template>
  <footer>
    <div class="row">
      <div class="col">
        <div class="footer-wrapper">
          <span class="footer-text">{{ D.ServerNow().getFullYear() }} Copyrights ©</span>
          <span class="footer-text blue"><a href="https://www.rehberimsensin.com/" target="_blank">Rehberim Sensin</a></span>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>